<template lang="pug">
    tbody.product-preview
        tr.product-table-row
            td.min(valign="top" rowspan="2")
                product-media-preview(:item="product")
            td.info(valign="top")
                .name(v-line-clamp="1") {{ product.name }}
                small.nr {{ product.nr }}
                template(v-if="selectedArticle")
                    span &nbsp;/&nbsp;
                    small {{ selectedArticle.sku }}
            td.min(valign="top" align="right")
                //- nobr.price {{ product.price.value | moneyFormat(currencyCode) }}
                .missing-price(v-if="price == undefined")
                    nobr.dimmed {{ $t('Missing Price') }}
                .sale-price(v-else-if="salePrice && salePrice < price")
                    .nobr
                        s.strike-through {{ price | moneyFormat(currencyCode) }}
                        //- span.percentage {{ (price - salePrice) / price * 100 | round(2) }}%
                    nobr.red {{ salePrice | moneyFormat(currencyCode) }}
                nobr(v-else) {{ price | moneyFormat(currencyCode) }}
        tr.product-table-row
            td(valign="bottom" colspan="2")
                .properties
                    .property-container
                        .property(v-for="pivot in selectablePropertyPivots")
                            property-pivot-values(
                                :key="pivot.property.id"
                                :property="pivot.property"
                                :currency="currencyCode"
                                :value-options="pivot.valueOptions"
                                :selected="getSelectedValueOption(pivot.property)"
                                @click="handlePropertySelection"
                            )
                transition(name="slide-decent-vertical" mode="out-in")
                    .stocks(v-if="selectedArticle && showStocks" key="stocks")
                        transition(name="slide-decent-vertical" mode="out-in")
                            table.default-table(v-if="selectedArticle.stocks.length")
                                thead
                                    tr
                                        th.min.icon
                                        th.col-left.name
                                            nobr {{ $t('Stock') }}
                                        th.col-left.sellable
                                            //- nobr {{ $t('Sellable From/To') }}
                                        th.col-center.qty
                                            nobr {{ $t('Available') }}
                                        th.min.actions
                                tbody
                                    tr.spacer
                                        td(colspan="5")
                                    tr.stock(v-for="stock in selectedArticle.stocks")
                                        td.min.icon
                                            span.icon.disabled(v-if="stock && stock.status !== 'enabled'")
                                                el-tooltip(effect="dark" :content="$t('Disabled in the stock settings')" placement="top")
                                                    i.el-icon-warning
                                            span.icon.sold-out(v-else-if="stock.pivot.qty <= 0")
                                                el-tooltip(effect="dark" :content="$t('Sold out')" placement="top")
                                                    i.el-icon-warning-outline
                                            span.icon.enabled(v-else)
                                                i.el-icon-success
                                        td.col-left.name
                                            nobr {{ stock.name }}
                                        td.col-left.sellable
                                            nobr.danger
                                                .from(v-if="stock.pivot.sellable_from") {{ $t('From') }}: {{ stock.pivot.sellable_from | timestamp2date($t('yyyy-MM-dd')) }}
                                                .to(v-if="stock.pivot.sellable_to") {{ $t('To') }}: {{ stock.pivot.sellable_to | timestamp2date($t('yyyy-MM-dd')) }}
                                        td.min.col-center.qty
                                            nobr {{ stock.pivot.qty }}
                                        td.min.col-right.actions
                                            nobr(v-loading="stock.loading")
                                                el-button(
                                                    v-if="stock && stock.pivot.qty > 0 && ! (activePointOfSale.stocks || []).find(el => el.id === stock.id)"
                                                    type="text"
                                                    :disabled="stock.loading"
                                                    @click.stop="requestArticle(stock)"
                                                ) {{ $t('request 1x') }}
                                                el-button(
                                                    v-else-if="stock && (activePointOfSale.stocks || []).find(el => el.id === stock.id)"
                                                    type="text"
                                                    :disabled="stock.loading"
                                                    @click.stop="takeBackArticle(stock, selectedArticle)"
                                                ) {{ $t('take back 1x') }}
                                    tr.spacer
                                        td(colspan="5")
                            .alert.warning(v-else key="alert")
                                p {{ $t('There is no stock for this article') }}
                transition(name="slide-decent-vertical" mode="out-in")
                    .alert.danger(
                        v-if="missingArticles || (articles.length && selectablePropertyPivots.length === selectedProperties.length && ! selectedArticle)"
                        key="alert"
                    )
                        p {{ $t('Could not find any related article') }}
                    .actions(
                        v-else-if="selectablePropertyPivots.length === selectedProperties.length"
                        key="actions"
                    )
                        // .spinner(v-if="loading")
                        el-button(
                            type="success"
                            size="mini"
                            icon="el-icon-fa-check fas"
                            :loading="loading"
                            @click="addSelectedArticleToCart"
                        ) {{ $t('Add to cart') }}
                        el-button.stocks(
                            v-if="product.manage_stock"
                            plain
                            type="primary"
                            size="mini"
                            icon="el-icon-fa-dolly fas"
                            :loading="loading"
                            @click="showStocks = !showStocks"
                        )
                            template(v-if="showStocks") {{ $t('Hide stocks') }}
                            template(v-else) {{ $t('Show stocks') }}
        tr.product-table-row
            td.divider(colspan="5")
                hr
</template>

<i18n>
{
    "de": {
        "Show stocks": "Bestände anzeigen",
        "Hide stocks": "Bestände verbergen",
        "Add to cart": "Zur Liste hinzufügen",
        "Could not find any related article": "Es konnten keine Artikel gefunden werden",
        "There is no stock for this article": "Für diesen Artikel gibt es keinen Bestand",
        "request 1x": "1x anfordern",
        "take back 1x": "1x zurücknehmen",
        "Available": "Verfügbar",
        "Sellable From/To": "Verkaufbar ab/bis",
        "From": "Ab",
        "Disabled in the stock settings": "In den Lagereinstellungen deaktiviert",
        "Sold out": "Ausverkauft",
        "To": "Bis",
        "Stock": "Lager",
        "Article not found": "Artikel konnte nicht gefunden werden",
        "Article requested successfully!": "Artikel wurde erfolgreich angefordert!",
        "Article has been taken back successfully!": "Der Artikel wurde erfolgreich zurückgenommen!",
        "Missing Price": "Preis fehlt",
        "Article could not be requested.": "Artikel konnte nicht angefordert werden."
    }
}
</i18n>

<script>

import _ from 'lodash';
import uniqid from 'uniqid';
import { useSetupStore, usePosSetupStore, usePosCartStore } from '@/stores';

import { moneyFormat, timestamp2date } from '@/filters';

import StockApi from '@/extensions/shop/pointOfSale/store/api/stock';
import ProductMediaPreview from './ProductMediaPreview';
import PropertyPivotValues from '@/extensions/shop/components/Products/PropertyPivotValues'

export default {
    name: 'ProductPreview',
    props: {
        product: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        selectedProperties: [],
        articles: [],
        loading: false,
        showStocks: false,
        missingArticles: false,
    }),
    components: {
        ProductMediaPreview,
        PropertyPivotValues
    },
    filters: {
        moneyFormat,
        timestamp2date
    },
    computed: {
        activeCms() {
            return useSetupStore().activeCms
        },
        posSetupStore() {
            return usePosSetupStore()
        },
        posCartStore() {
            return usePosCartStore()
        },
        currencyCode() {
            return _.get(this.currency, 'iso4217')
        },
        articlePropertyPivots() {
            return this.product.propertyPivots.filter(el => el.property.article_required === true)
        },
        selectablePropertyPivots() {
            return this.product.propertyPivots
                .filter(el => el.valueOptions.length > 1 || el.property.article_required === true).map(el => {
                    if (this.articles && this.articles.length) {
                        const field = el.property.propType.value_field;
                        el.valueOptions.forEach(v => {
                            const value = v[field];
                            const articles = this.articles.filter(article => {
                                let match = true;
                                article.propertyPivots.forEach(ap => {
                                    if (ap.property.id === el.property.id && ap.valueOption[field] !== value) match = false;
                                });
                                return match;
                            });

                            if (! articles.length) {
                                v.disabled = true

                                const sp = this.selectedProperties.find(sp => sp.property.id === el.property.id);
                                if (sp && sp.valueOption[field] === value) this.handlePropertySelection(el.property, v);
                            }
                        })
                    }
                    return el
                })
        },
        nonSelectablePropertyPivots() {
            return this.product.propertyPivots.filter(el => el.valueOptions.length === 1)
        },
        surcharge() {
            let surcharge = 0
            this.nonSelectablePropertyPivots.forEach(el => {
                const price = _.get(el.valueOptions[0], 'pivot.price')
                    || _.get(el.valueOptions[0], 'price')

                if (price && price.value > 0) surcharge += price.value
            })
            this.selectedProperties.forEach(el => {
                const price = _.get(el.valueOption, 'pivot.price')
                    || _.get(el.valueOption, 'price')
                if (price && price.value > 0) surcharge += price.value
            })

            return surcharge
        },
        selectedArticle() {
            const articles = this.articles.filter(article => {
                let match = true;
                article.propertyPivots.forEach(ap => {
                    const field = ap.property.propType.value_field;
                    const sp = this.selectedProperties.find(sp => sp.property.id === ap.property.id);
                    if (! sp || ap.valueOption[field] !== sp.valueOption[field]) match = false;
                });
                return match;
            });

            if (articles.length === 1) {
                // let article = _.cloneDeep(articles[0]);
                let article = articles[0];
                const stocks = _.get(this.activePointOfSale, 'stocks') || []
                stocks.forEach(stock => {
                    if (! article.stocks.find(el => el.id === stock.id)) {
                        stock = _.cloneDeep(stock);
                        stock.pivot = {
                            id: uniqid('new:'),
                            qty: 0,
                        }
                        this.$set(article.stocks, article.stocks.length, stock);
                        // article.stocks.push(stock);
                    }
                })
                return article;
            }
        },
        price() {
            let price = _.get(this.product.price, 'value')
            if (this.selectedArticle) price = _.get(this.selectedArticle.price, 'value') || price
            return price + this.surcharge
        },
        salePrice() {
            let price = _.get(this.product.salePrice, 'value')
            if (this.selectedArticle) price = _.get(this.selectedArticle.salePrice, 'value') || price
            return price + this.surcharge
        },
        activePointOfSale() {
            return this.posSetupStore.activePointOfSale;
        },
        currency() {
            return this.posSetupStore.currency;
        }
    },
    methods: {
        addSelectedArticleToCart() {
            this.$emit('add-article-to-cart', this.selectedArticle, this.selectedProperties)
            setTimeout(() => {
                this.selectedProperties = []
            }, 300)
        },
        handlePropertySelection(property, valueOption) {
            const i = this.selectedProperties.findIndex(el => el.property.id === property.id)
            if (i >= 0) {
                if (this.selectedProperties[i].valueOption.id === valueOption.id) this.$delete(this.selectedProperties, i)
                else this.$set(this.selectedProperties, i, { property, valueOption })
            } else {
                this.$set(this.selectedProperties, this.selectedProperties.length, { property, valueOption })
            }

            if (! this.articles.length && ! this.loading) this.loadArticles();
        },
        async loadArticles() {
            this.loading = true
            this.missingArticles = false
            this.articles = await this.fetchArticles({ product: parseInt(this.product.id) })
                .catch(err => {
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                })
                .finally(() => {
                    this.loading = false
                })

            if (! this.articles.length) this.missingArticles = true
        },
        requestArticle(stock) {
            this.$set(stock, 'loading', true)

            const handleError = () => {
                this.$notify.error({
                    title: this.$t('An error occurred!'),
                    message: this.$t('Article could not be requested.'),
                    iconClass: 'fas el-icon-fa-times',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000,
                })
            }

            this.requestArticles({
                shop: this.activeCms.shop,
                items: [{
                    id: uniqid('new:'),
                    qty: 1,
                    stocks: [{ id: stock.id }],
                    article: { id: this.selectedArticle.id },
                    propertyValueOptions: this.selectedProperties.map(prop => prop.valueOption)
                }],
            })
                .then(purchase => {
                    if (purchase.errors && purchase.errors.length) {
                        handleError()
                    } else {
                        this.$notify.success({
                            title: this.$t('Article requested successfully!'),
                            iconClass: 'fas el-icon-fa-check',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }
                })
                .catch(err => {
                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err)
                    handleError()
                })
                .finally(() => {
                    this.$delete(stock, 'loading')
                })
        },
        async takeBackArticle(stock, article) {
            this.$set(stock, 'loading', true)

            const payload = {
                uniqid: uniqid(),
                stock: { id: stock.id },
                action: 'increase',
                pointOfSale: this.activePointOfSale,
                skus: [ article.sku ]
            }

            let error
            await StockApi.updateStock(payload)
                .catch(err => {
                    const { networkError, graphQLErrors } = err;
                    const code = _.get(graphQLErrors, '0.code');
                    error = true;

                    if (code === 404) {
                        this.$notify.error({
                            title: this.$t('Article not found'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    } else {
                        this.$notify.error({
                            title: this.$t('An error occurred!'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }

                    console.error(err)
                })

            this.$delete(stock, 'loading')

            if (! error) {
                this.$set(stock.pivot, 'qty', stock.pivot.qty + 1)

                // // create coupon?
                // this.$emit('create-coupon', _.get(article, 'price.value'))
                this.$emit('ask-for-refund', { article, stock, price: _.get(article, 'price.value') })

                this.$notify.success({
                    title: this.$t('Article has been taken back successfully!'),
                    iconClass: 'fas el-icon-fa-check',
                    position: 'bottom-left',
                    customClass: 'dark',
                    duration: 8000,
                })
            }
        },
        getSelectedValueOption(property) {
            const selectedProperty = this.selectedProperties.find(el => el.property.id === property.id)
            if (selectedProperty) return selectedProperty.valueOption
            else return null
        },
        fetchArticles(payload) {
            return this.posCartStore.fetchArticles(payload);
        },
        requestArticles(payload) {
            return this.posCartStore.requestArticles(payload);
        }
    },
    mounted() {
        if (! this.articlePropertyPivots.length) {
            this.loadArticles()
        }
    }
}
</script>

<style lang="sass" scoped>
.product-preview
    .name, .price
        font-weight: bold
    .nr
        font-size: 0.8em
    .property-container
        display: flex
        flex-direction: column
        gap: 1rem
        row-gap: 4px
        flex-wrap: wrap
        align-items: baseline
        ::v-deep
            .property-value
                label
                    font-size: 0.8em
                    display: block
                    margin-bottom: 2px
                    &:after
                        content: ''
        // .property + .property
        //     margin-top: 4px
    .actions
        margin-top: 0.6rem
    .alert
        margin: 0
        margin-top: 0.6rem
    .media,
    .placeholder
        position: sticky
        top: 0
    .stocks table.default-table
        width: 400px
        th
            padding: 0.6rem 1rem
        td
            padding: 0 1rem
        .min.icon
            padding-left: 8px
            padding-right: 0
        .name
            padding-left: 8px

        .icon
            i
                font-size: 1.2rem
            &.sold-out
                color: $--color-warning
            &.enabled
                color: $--color-success
            &.disabled
                color: $--color-danger

        .from, .to
            display: inline-block
        .from + .to
            margin-left: 1rem
        .actions::v-deep
            .el-loading-mask
                background: rgba(250, 250, 250, 0.8)
                pointer-events: none
                svg
                    width: 24px
                    circle
                        stroke-width: 4px

    .nobr
        white-space: nowrap

    .danger
        color: $--color-danger

    .sale-price
        text-align: right
        s
            display: inline-block
            // font-size: 0.6em
            // font-weight: bold
            text-decoration: none
            color: rgba(0,0,0,0.5)
        .red
            color: $--color-danger
        .strike-through
            position: relative
            &:before
                position: absolute
                content: ""
                left: -3px
                top: 50%
                right: -3px
                border-top: 1px solid rgba(0,0,0,0.5)
                // border-color: $--color-info
                transform: rotate(-5deg)

@keyframes spin
    0%
        transform: rotate(0deg)
    100%
        transform: rotate(360deg)

.spinner
    width: 20px
    height: 20px
    display: inline-block
    margin-right: 1rem
    top: 0.4rem
    position: relative

.el-button--text
    padding: 0

</style>
